export default {
  data() {
    return {
      disabled: false,
      text: "Get verification code"
    };
  },
  methods: {
    sendCode() {
      if (this.disabled) return;
      this.disabled = true;
      let n = 120;
      this.text = " " + n + "s";
      const run = setInterval(() => {
        n = n - 1;
        if (n < 0) {
          clearInterval(run);
        }
        this.text = " " + n + "s";
        if (this.text < " " + 0 + "s") {
          this.disabled = false;
          this.text = "Reload";
        }
      }, 1000);
    }
  }
};
